<template>
  <div>
    <div class="h-30">
      <span class="form-item">条件间逻辑关系</span>
      <el-button class="fr" type="primary" size="small" @click="checkValid">检查是否正确</el-button>
    </div>
    <el-input type="textarea" v-model="childValue" :rows="4" @input="change"></el-input>
    <div class="form-tips lh-20">
      说明：为空则全部条件为AND关系，填写条件名和AND、OR以及括号、双引号(均为英文半角)来组合条件间的关系，慎重以免报错，若解析失败，则会以全部为AND来解析。例子：("条件名1"AND"条件名2")OR("条件名1"AND"条件名3")
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default() {
          return ''
        }
      },
      beforeCheck: {
        type: Function,
        default() {
          return () => {}
        }
      }
    },
    data() {
      return {
        childValue: ''
      }
    },
    created() {
      this.childValue = this.value
    },
    methods: {
      /**
       * 检查表达式是否符合要求
       */
      checkValid() {
        if (this.beforeCheck) {
          this.beforeCheck()
        }
        if (!this.childValue || !this.childValue.length) {
          _g.toastMsg(this, 'warning', '表达式为空！')
          return
        }
        // |(\()|(\))
        let vailed = true
        // 检测条件名是否用括号包裹，以及括号是否为半角英文
        let result = this.childValue.replace(/(AND)|(OR)|(\(".+?\"\))/g, '')
        // console.log("取出正确格式", result)
        if (result.length > 0) {
          vailed = false
          if (result.indexOf('”') >= 0 || result.indexOf('“') >= 0) {
            _g.toastMsg(this, 'warning', '请使用英文半角双引号！')
          } else if (result.indexOf('（') >= 0 || result.indexOf('）') >= 0) {
            _g.toastMsg(this, 'warning', '请使用英文半角括号！')
          } else {
            // 请检查条件名是否用半角双引号包裹
            _g.toastMsg(this, 'warning', '请检查表达式逻辑关系、符号是否正确！')
          }
          return vailed
        }
        // 取出条件名检测是否存在
        let regA = /\".+?\"/g
        let conNames = this.childValue.match(regA)
        // console.log("conNames", conNames)
        // 去掉匹配的结果中的双引号，只剩下条件名
        conNames = conNames.join('||').replace(/(\")|(\")/g, '').split('||')
        // console.log("conNames", conNames)
        // 去掉表达式中的条件名只留下括号和逻辑名称
        let noNames = this.childValue.replace(regA, '')
        // 两个条件一定要存在逻辑关系
        let conNameNumber = conNames.length
        if (conNameNumber > 1) {
          let logicAndNumber = noNames.match(/AND/g)
          let logicOrNumber = noNames.match(/OR/g)
          let logicNumber = (!logicAndNumber ? 0 : logicAndNumber.length) + (!logicOrNumber ? 0 : logicOrNumber.length)
          // console.log("条件个数", logicNumber)
          if (logicNumber < conNames.length - 1) {
            _g.toastMsg(this, 'warning', '缺少条件之间逻辑关系')
            vailed = false
          }
        }
        // console.log('noNames', noNames)
        // 检测括号是否成对存在
        // 删除括号之外的字符
        let regB = /[^\(\)]/g
        let regC = /\(\)/g
        let onlyBracket = noNames.replace(regB, '')
        let dupBracket = onlyBracket.replace(regC, '')
        if (dupBracket.length > 0) {
          vailed = false
          _g.toastMsg(this, 'warning', '存在未闭合的括号！')
          return vailed
        }
        // 判断是否有无括号存在
        let rege = /^(\(\))+$/
        if (!rege.test(onlyBracket)) {
          vailed = false
          _g.toastMsg(this, 'warning', '条件缺少括号！')
          return vailed
        }
        // 检测是否有无法识别的逻辑名称
        let onlyLogic = noNames.replace(/(\()|(\))/g, '')
        result = onlyLogic.replace(/(AND)|(OR)/g, '')
        // console.log(result)
        if (result.length > 0) {
          vailed = false
          _g.toastMsg(this, 'error', '存在未知的逻辑！')
          return vailed
        }
        // _g.toastMsg(this, 'success', '格式检查通过！')
        this.$emit('checkValid')
      },
      change() {
        this.$emit('input', this.childValue)
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.childValue = this.value
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// conditionCheck.vue?04167d93